import { useEffect } from 'react';
import { whiteboardCreated } from 'features/layout/features/content/actions';
import { WhiteboardCreatedOptions } from 'features/layout/features/content/types';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { useWhiteboard } from 'features/whiteboard/hooks/useWhiteboard';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { selectWhiteboardIsRestorable } from 'features/whiteboard/drafts/whiteboardDraftsSlice';

const CreateNewWhiteboardConfirmationModal = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const { isFeatureAvailable } = useWhiteboard();

  const shouldClose = !isFeatureAvailable;

  useEffect(() => {
    if (shouldClose) {
      dispatch(closeModal('createNewWhiteboardConfirmation'));
    }
  }, [shouldClose, dispatch]);

  const modalData = useAppSelector(selectActiveModalData);
  const whiteboardIsRestorable = useAppSelector(selectWhiteboardIsRestorable);

  // The board the new one replaces is either kept by the session or kept only on this device, and
  // the two promise the person different things.
  const translationKey = whiteboardIsRestorable
    ? 'create_over_restorable_whiteboard'
    : 'create_new_whiteboard_confirmation';

  const handleOk = () => {
    dispatch(whiteboardCreated(modalData.options as WhiteboardCreatedOptions));
    dispatch(closeModal('createNewWhiteboardConfirmation'));
  };

  const handleCancel = () => {
    dispatch(closeModal('createNewWhiteboardConfirmation'));
  };

  return (
    <ConfirmationDialog
      open={!shouldClose}
      maxWidth="sm"
      title={t(`${translationKey}.title`)}
      description={t(`${translationKey}.description`)}
      cancelText={t(`${translationKey}.btn_cancel_label`)}
      okText={t(`${translationKey}.btn_ok_label`)}
      onOk={handleOk}
      onCancel={handleCancel}
      preventClose
      hideCloseButton
    />
  );
};

export default CreateNewWhiteboardConfirmationModal;
